class SignupRole {
  constructor(el) {
    this.el = el;
    this.$el = $(el);

    this.$applicant = this.$el.find('[data-signup-role="applicant"]');
    this.$agent = this.$el.find('[data-signup-role="agent"]');
    this.$roleOption = this.$el.find('[data-signup-role]');
    this.$input = this.$el.closest('form').find('[data-signup-role="input"]');

    this.$form = this.$el.closest('form');
    // this.$form[0]
    console.log('this.$form[0]: ', this.$form[0]);

    this.onClickOption = this.onClickOption.bind(this);
    this.bindEvents();

    window.grapp.instances = window.grapp.instances ? [...window.grapp.instances, this] : [this];
  }

  bindEvents() {
    this.$roleOption.on('click', this.onClickOption);
  }

  onClickOption(e) {
    e.preventDefault();
    const $target = $(e.currentTarget)
    const role = $target.data('signup-role');

    this.$input.val(role);
    this.$roleOption.removeClass('selected');
    $target.addClass('selected');
    const planId = this.$roleOption.find('input[type="radio"]:checked').data('ms-member');

    if (planId) {
      this.$form.attr('data-ms-plan:add', planId);
    }
  }

  static init() {
    $('[data-js-component="signup-role"]').each((i, el) => new SignupRole(el));
  }
}

SignupRole.init();
